(ns rlws.iot-cloud.frontend.routes
  (:require [re-frame.core :as rf] 
            [rlws.iot-cloud.frontend.site :as site]))

(def pages
  [{:path "/home"
    :name :homepage
    :link-text "Home"
    :icon "menu-home-icon"
    :permission-required :view-home
    :controllers
    [{:start #(do (rf/dispatch [:fetch/data [:assets] (site/resource-path :assets)])
                  (rf/dispatch [:fetch/data [:all-alerts] (site/resource-path :alerts)])
                  (rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)])
                  (rf/dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes)]) 
                  (rf/dispatch [:rlws.iot-cloud.frontend.events/start-watch-alerts nil nil nil 120000]))
      :stop #(rf/dispatch [:rlws.iot-cloud.frontend.events/stop-watch-alerts])
      }]}

   ;; Assets

   {:path "/assets"
    :icon "menu-assets-icon"
    :name :assets
    :active-pages #{:asset :asset-profile :iqube-detail}
    :permission-required :view-assets
    :controllers 
     [{:start #(rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)])}
      {:start #(rf/dispatch [:fetch/data [:assets] (site/resource-path :assets)])}
      {:start #(rf/dispatch [:fetch/data [:sites] (site/resource-path :sites)])}
      {:start #(rf/dispatch [:fetch/data [:iqubes] (site/resource-path :iqubes)])}
      {:start #(rf/dispatch [:fetch/data [:scales] (site/resource-path :scales)])}] 
    :link-text "Assets"}
   {:path "/add-asset"
    :name :add-asset
    :permission-required :modify-assets
    :controllers
    [{:start #(rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)])}]
    :link-text "Assets"}
   {:path "/assets/:asset"
    :name :asset
    :permission-required :view-assets
    :link-text "Asset Overview"
    :controllers
    [{:parameters {:path [:asset] :query [:iqube :scale]}
      :start (fn [{{:keys [asset]} :path {:keys [iqube scale]} :query}]
               (when iqube (rf/dispatch [:fetch/data [:iqube] (site/resource-path :iqubes iqube)]))
               (when scale (rf/dispatch [:fetch/data [:scale] (site/resource-path :scales scale)]))
               (rf/dispatch [:fetch/data [:asset] (site/resource-path :assets asset)])
               (rf/dispatch [:rlws.iot-cloud.frontend.events/fetch-asset-images asset])
               (rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)])
               (rf/dispatch [:fetch/data [:sites] (site/resource-path :sites)])
               (rf/dispatch [:fetch/data [:assets] (site/resource-path :assets)])
               (rf/dispatch [:fetch/data [:scales] (site/resource-path :scales)])
               (rf/dispatch [:fetch/data [:iqubes] (site/resource-path :iqubes)])
               (rf/dispatch [:fetch/data [:documents] (site/resource-path :documents) {:asset asset}]))
      :stop #(do (rf/dispatch [:rlws.iot-cloud.frontend.events/clear-data [:status]])
                 (rf/dispatch [:rlws.iot-cloud.frontend.events/stop-watch-alerts])
                 )}]}
   {:path "/assets/:asset/edit"
    :name :edit-asset
    :permission-required :modify-assets
    :link-text "Edit Asset"
    :controllers
    [{:parameters {:path [:asset]}
      :start (fn [{{:keys [asset]} :path}]
               (rf/dispatch [:fetch/data [:asset] (site/resource-path :assets asset)])
               (rf/dispatch [:rlws.iot-cloud.frontend.events/fetch-asset-images asset])
               (rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)]))}]}
   {:path "/iqubes/:iqube-detail"
    :name :iqube-detail
    :link-text "iQUBE Detail"
    :permission-required :view-assets
    :controllers [{:parameters {:path [:iqube-detail]}
                   :start (fn [{{:keys [iqube-detail]} :path}]
                            (rf/dispatch [:fetch/data [:iqube] (site/resource-path :iqubes iqube-detail)])
                            (rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)])
                            (rf/dispatch [:fetch/data [:sites] (site/resource-path :sites)])
                            (rf/dispatch [:fetch/data [:assets] (site/resource-path :assets)])
                            (rf/dispatch [:fetch/data [:scales] (site/resource-path :scales)])
                            (rf/dispatch [:fetch/data [:iqubes] (site/resource-path :iqubes)]))
                   :stop #(do (rf/dispatch [:rlws.iot-cloud.frontend.events/clear-live-cells])
                              (rf/dispatch [:rlws.iot-cloud.frontend.events/clear-live]))}]}

   ;; Customers

   {:path "/customers"
    :icon "menu-customers-icon"
    :active-pages #{:customer :site}
    :name :customers
    :permission-required :view-customers
    :controllers
    [{:start #(rf/dispatch [:fetch/data [:customers] (site/resource-path :customers)])}
     {:start #(rf/dispatch [:fetch/data [:sites] (site/resource-path :sites)])}
     {:start #(rf/dispatch [:fetch/data [:iqubes] (site/resource-path :iqubes)])}
     {:start #(rf/dispatch [:fetch/data [:scales] (site/resource-path :scales)])}] 
    :link-text "Customers"}
   {:path "/customers/:customer"
    :name :customer
    :permission-required :view-customers
    :link-text "Customers"
    :controllers
    [{:parameters {:path [:customer]}
      :start (fn [{{:keys [customer]} :path}]
               (rf/dispatch [:fetch/data [:assets] (site/resource-path :assets)])
               (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers customer)]))}]}
   {:path "/add-customer"
    :name :add-customer
    :permission-required :modify-customers
    :controllers
    [{:start #(rf/dispatch [:fetch/data [:dealerships] (site/resource-path :dealerships)])}]
    :link-text "Customers"}
   {:path "/sites/:site"
    :name :site
    :permission-required :view-customers
    :link-text "Site Overview"
    :controllers
    [{:parameters {:path [:site]}
      :start (fn [{{:keys [site]} :path}]
               (rf/dispatch [:fetch/data [:site] (site/resource-path :sites site)]))}]}

   {:path "/oauth-login"
    :name :oauth-login
    :no-auth true
    :controllers
    [{:parameters {:query [:code]}
      :start #(rf/dispatch [:oauth-login (-> % :query :code)])}]}

   {:path "/account-settings"
    :name :account-settings
    :link-text "Account Settings"}

   {:path "/notification-settings"
    :name :notification-settings
    :link-text "Notification Settings"
    :controllers
    [{:stop #(rf/dispatch [:rlws.iot-cloud.frontend.events/set-current-scale nil])}
     {:stop #(rf/dispatch [:rlws.iot-cloud.frontend.events/set-current-scale-temporary-checkbox false])}
     {:stop #(rf/dispatch [:rlws.iot-cloud.frontend.events/set-current-scale-temporary-timeout nil])}
     {:stop #(rf/dispatch [:rlws.iot-cloud.frontend.events/set-current-scale-timeout nil])}
     {:stop #(rf/dispatch [:rlws.iot-cloud.frontend.events/set-submitting-notifications false])}]}

   {:path "/login"
    :name :login
    :no-auth true}])

(def disused-pages
  [{:path "/home"
    :name :admin/homepage
    :link-text "Home"
    :icon "fa-home"}])

(def routes
  ["/app"
   (for [{:keys [path] :as page} pages]
     [path page])])
